<template>
  <div class="flex max-w-2xl flex-col gap-6">
    <div class="flex flex-col gap-2">
      <Label for="setup-company">{{ t('admin.setup.identity.company.label') }}</Label>
      <Input
        id="setup-company"
        v-model="form.COMPANY_NAME"
        aria-describedby="setup-company-description"
        data-test-id="setup-company-input"
      />
      <p id="setup-company-description" class="text-sm text-muted-foreground">
        {{ t('admin.setup.identity.company.description') }}
      </p>
    </div>
    <div class="flex flex-col gap-2">
      <Label for="setup-title">{{ t('admin.setup.identity.platform.label') }}</Label>
      <Input
        id="setup-title"
        v-model="form.TITLE"
        aria-describedby="setup-title-description"
        data-test-id="setup-title-input"
      />
      <p id="setup-title-description" class="text-sm text-muted-foreground">
        {{ t('admin.setup.identity.platform.description') }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { usePlatformSetup } from '@/features/admin/platform-setup/hooks/use-platform-setup.hook'
import { useI18n } from '@/lib/i18n'

const { t } = useI18n()
const { form } = usePlatformSetup()
</script>
